import { render } from "./mIndex4.vue?vue&type=template&id=6d201221&scoped=true"
import script from "./mIndex4.vue?vue&type=script&lang=js"
export * from "./mIndex4.vue?vue&type=script&lang=js"

import "./mIndex4.vue?vue&type=style&index=0&id=6d201221&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d201221"]])

export default __exports__